import React from 'react';

import './loaderComponent.css';

const LoaderComponent = () => {
  return (
    <div className="et-v2-loader-container">
      <div className="et-v2-loader-content-wrap">
        <div className="et-v2-loader-dot et-v2-loader-dot-1"></div>
        <div className="et-v2-loader-dot et-v2-loader-dot-2"></div>
        <div className="et-v2-loader-dot et-v2-loader-dot-3"></div>
      </div>
    </div>
  );
};

export default LoaderComponent;
